// extracted by mini-css-extract-plugin
export default {"addToCartControl":"G2-z","giftCard":"H2-z","btnContainer":"I2-z","cartButton":"J2-z","disabled":"K2-z","stockMessage":"L2-z"};